module.exports = __webpack_public_path__ + "img/content.76504221.png";